export const useBidService = () => {
  const auth = useAuth()

  const submitBid = async ({
    productId,
    userId,
    productUserId,
    mobile,
    bid,
    description,
    lastPrice
  }) => {
    const body = {
      product_id: productId,
      user_id: userId,
      product_user_id: productUserId,
      mobile,
      bid_amount: bid,
      description: description || '',
      last_price: lastPrice
    }

    const headers = auth.getAuthHeaders()

    const data = await $fetch('/market/api/products/bid', {
      method: 'POST',
      headers,
      body
    })

    return data
  }

  return {
    submitBid
  }
}
